function animateWaveFlow(svgRoot) {
	const flowPaths = svgRoot.querySelectorAll(".wave-flow-line");
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	flowPaths.forEach((path, index) => {
		const length = path.getTotalLength();
		const dash = length * 0.18;

		path.style.strokeDasharray = `${dash} ${length}`;
		if (prefersReducedMotion) {
			gsap.set(path, { strokeDashoffset: 0 });
			return;
		}


		gsap.fromTo(
			path,
			{ strokeDashoffset: length + dash },
			{
				strokeDashoffset: 0,
				duration: 5,
				ease: "none",
				repeat: -1,
				delay: index * 1.4,
			},
		);
	});
}

async function injectWave() {
	const placeholders = document.querySelectorAll("[data-svg-inject]");

	for (const placeholder of placeholders) {
		try {
			const source = placeholder.getAttribute("data-svg-inject");
			if (!source) {
				continue;
			}

			const response = await fetch(source);
			if (!response.ok) {
				continue;
			}

			const markup = await response.text();
			const svg = new DOMParser().parseFromString(markup, "image/svg+xml").querySelector("svg");

			if (!svg) {
				continue;
			}

			svg.classList.add(...placeholder.classList);
			if (placeholder.hasAttribute("aria-hidden")) {
				svg.setAttribute("aria-hidden", placeholder.getAttribute("aria-hidden"));
			}
			svg.setAttribute("focusable", "false");
			placeholder.replaceWith(svg);
			animateWaveFlow(svg);
		} catch (error) {
			// Mantém o placeholder caso o fetch do SVG falhe
		}
	}
}

function initBannerWaveReveal() {
	const waves = document.querySelectorAll("#banner .banner-wave, #about-banner .banner-wave");

	if (!waves.length) {
		return;
	}

	waves.forEach((wave) => {
		if (wave.dataset.bannerWaveRevealReady === "true") {
			return;
		}

		wave.dataset.bannerWaveRevealReady = "true";

		if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
			gsap.set(wave, { autoAlpha: 1, clipPath: "inset(0 0% 0 0)" });
			return;
		}

		gsap.fromTo(
			wave,
			{ autoAlpha: 1, clipPath: "inset(0 100% 0 0)" },
			{ clipPath: "inset(0 0% 0 0)", duration: 1.65, delay: 0.18, ease: "power2.inOut" },
		);
	});
}

function initBannerCircleAnimation() {
	const banner = document.querySelector("#about-banner");
	const circle = banner ? banner.querySelector(".banner-circle") : null;

	if (!banner || !circle || circle.dataset.bannerCircleAnimationReady === "true") {
		return;
	}

	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	circle.dataset.bannerCircleAnimationReady = "true";
	gsap.set(circle, { transformOrigin: "50% 50%" });

	if (prefersReducedMotion) {
		gsap.set(circle, { autoAlpha: 1, clearProps: "transform,filter" });
		return;
	}

	const moveCircle = gsap.quickTo(circle, "x", { duration: 0.48, ease: "power3.out" });
	const liftCircle = gsap.quickTo(circle, "y", { duration: 0.48, ease: "power3.out" });
	const rotateCircle = gsap.quickTo(circle, "rotate", { duration: 0.48, ease: "power3.out" });

	gsap.fromTo(
		circle,
		{ autoAlpha: 0, scale: 0.42, rotate: -6, filter: "blur(1px) saturate(1.12)" },
		{
			autoAlpha: 1,
			scale: 1,
			rotate: 0,
			filter: "blur(0px) saturate(1)",
			duration: 1.35,
			delay: 0.18,
			ease: "power3.out",
		},
	);


	banner.addEventListener("pointermove", (event) => {
		const bounds = circle.getBoundingClientRect();
		const offsetX = (event.clientX - bounds.left) / bounds.width - 0.5;
		const offsetY = (event.clientY - bounds.top) / bounds.height - 0.5;

		moveCircle(offsetX * 34);
		liftCircle(offsetY * 24);
		rotateCircle(offsetX * 3);
	});

	banner.addEventListener("pointerleave", () => {
		moveCircle(0);
		liftCircle(0);
		rotateCircle(0);
	});
}
function wrapBannerPhrases(element, className) {
	if (!element || element.dataset.bannerPhrasesReady === "true") {
		return;
	}

	const text = element.textContent.trim().replace(/\s+/g, " ");
	const phrases = text.match(/[^,.;!?]+[,.;!?]?/g) || [text];
	const fragment = document.createDocumentFragment();

	phrases.forEach((phraseText, index) => {
		const phrase = document.createElement("span");
		phrase.className = className;
		phrase.textContent = phraseText.trim();
		fragment.appendChild(phrase);

		if (index < phrases.length - 1) {
			fragment.appendChild(document.createTextNode(" "));
		}
	});

	element.textContent = "";
	element.appendChild(fragment);
	element.dataset.bannerPhrasesReady = "true";
}

function getDiagonalArrow(scope, selector) {
	const arrow = scope ? scope.querySelector(selector) : null;

	if (arrow) {
		arrow.dataset.diagonalArrowAnimation = "handled";
	}

	return arrow;
}

function diagonalArrowFrom() {
	return { autoAlpha: 0, x: -34, y: 34, rotate: -18, scale: 0.82 };
}

function diagonalArrowTo(options = {}) {
	return {
		autoAlpha: 1,
		x: 0,
		y: 0,
		rotate: 0,
		scale: 1,
		duration: 0.78,
		ease: "power3.out",
		...options,
	};
}

function initHeaderTitleAnimation() {
	const headerTitle = document.querySelector("#headerTitle");

	if (!headerTitle || headerTitle.dataset.headerTitleAnimationReady === "true") {
		return;
	}

	const title = headerTitle.querySelector("h1");
	const text = headerTitle.querySelector(".texts p");
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	const elements = [title, text].filter(Boolean);

	headerTitle.dataset.headerTitleAnimationReady = "true";

	if (!elements.length) {
		return;
	}

	if (prefersReducedMotion) {
		gsap.set(elements, { autoAlpha: 1, clearProps: "transform" });
		return;
	}

	const timelineOptions = {
		defaults: { ease: "power3.out" },
	};

	if (typeof ScrollTrigger !== "undefined") {
		timelineOptions.scrollTrigger = {
			trigger: headerTitle,
			start: "top 80%",
			toggleActions: "play none none none",
		};
	}

	gsap.timeline(timelineOptions)
		.fromTo(elements, { autoAlpha: 0, y: 34 }, { autoAlpha: 1, y: 0, duration: 0.78, stagger: 0.12 });
}

function initBannerTextAnimation() {
	const banner = document.querySelector("[data-banner-animation]");

	if (!banner) {
		return;
	}

	const heading = banner.querySelector("[data-banner-heading]");
	const title = heading ? heading.querySelectorAll("h1, h2") : [];
	const rule = heading ? heading.querySelector("hr") : null;
	const copy = banner.querySelector("[data-banner-copy] p");
	const scrollDown = banner.querySelector(".scroll-down");

	wrapBannerPhrases(copy, "banner-fill-word");

	const copyPhrases = banner.querySelectorAll(".banner-fill-word");
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	if (prefersReducedMotion) {
		gsap.set([title, copyPhrases, rule, scrollDown], {
			autoAlpha: 1,
			clearProps: "transform,filter,clipPath",
		});
		gsap.set(copyPhrases, { backgroundPosition: "0% 0", opacity: 1 });
		return;
	}

	gsap.set(rule, { transformOrigin: "50% 50%" });
	gsap.set(copyPhrases, { backgroundPosition: "100% 0", opacity: 0.42 });

	gsap.timeline({ defaults: { ease: "power3.out" }, delay: 0.22 })
		.from(title, {
			autoAlpha: 0,
			y: 28,
			duration: 1,
			ease: "power3.out",
		})
		.from(rule, {
			scaleX: 0,
			autoAlpha: 0,
			duration: 0.72,
			ease: "power2.inOut",
		}, "-=0.42")
		.from(scrollDown, {
			autoAlpha: 0,
			y: -16,
			duration: 0.62,
		}, "-=0.12")
		.to(scrollDown, {
			y: 8,
			duration: 1.25,
			repeat: -1,
			yoyo: true,
			ease: "sine.inOut",
		});

	if (typeof ScrollTrigger === "undefined") {
		gsap.to(copyPhrases, {
			backgroundPosition: "0% 0",
			opacity: 1,
			duration: 0.8,
			stagger: 0.18,
			ease: "power2.out",
			delay: 0.8,
		});
		return;
	}

	gsap.timeline({
		scrollTrigger: {
			trigger: copy,
			start: "top 86%",
			end: "bottom 52%",
			scrub: 0.75,
		},
	})
		.to(copyPhrases, {
			backgroundPosition: "0% 0",
			opacity: 1,
			ease: "none",
			stagger: 0.32,
		})
		.to(scrollDown, {
			autoAlpha: 1,
			scale: 1.04,
			duration: 0.18,
			ease: "none",
		}, 0.72);
}

function wrapAboutWords(element) {
	if (!element || element.dataset.aboutWordsReady === "true") {
		return;
	}

	const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
		acceptNode(node) {
			return node.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
		},
	});
	const textNodes = [];

	while (walker.nextNode()) {
		textNodes.push(walker.currentNode);
	}

	textNodes.forEach((node) => {
		const fragment = document.createDocumentFragment();
		node.nodeValue.split(/(\s+)/).forEach((part) => {
			if (!part) {
				return;
			}

			if (/\s+/.test(part)) {
				fragment.appendChild(document.createTextNode(part));
				return;
			}

			const word = document.createElement("span");
			word.className = "about-word";
			word.textContent = part;
			fragment.appendChild(word);
		});
		node.replaceWith(fragment);
	});

	element.dataset.aboutWordsReady = "true";
}

function initAboutInsideAnimation() {
	const section = document.querySelector("[data-about-inside-animation]");

	if (!section || section.dataset.aboutInsideAnimationReady === "true") {
		return;
	}

	const title = section.querySelector(".titles .bigTitle");
	const pillsList = section.querySelector(".titles ul");
	const pills = pillsList ? pillsList.querySelectorAll("li") : [];
	const textItems = section.querySelectorAll(".texts ul > li");
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	section.dataset.aboutInsideAnimationReady = "true";
	if (prefersReducedMotion) {
		gsap.set([title, pills, textItems], { autoAlpha: 1, clearProps: "transform" });
		return;
	}

	gsap.fromTo(
		title,
		{ autoAlpha: 0, y: 34 },
		{
			autoAlpha: 1,
			y: 0,
			duration: 0.78,
			ease: "power3.out",
			scrollTrigger: {
				trigger: title,
				start: "top 84%",
				toggleActions: "play none none none",
			},
		},
	);

	if (pillsList && pills.length) {
		gsap.fromTo(
			pills,
			{ autoAlpha: 0, y: 26, scale: 0.82, rotation: -3 },
			{
				autoAlpha: 1,
				y: 0,
				scale: 1,
				rotation: 0,
				duration: 0.7,
				ease: "back.out(1.7)",
				stagger: 0.075,
				scrollTrigger: {
					trigger: pillsList,
					start: "top 84%",
					toggleActions: "play none none none",
				},
			},
		);
	}

	textItems.forEach((item) => {
		gsap.fromTo(
			item,
			{ autoAlpha: 0, y: 34 },
			{
				autoAlpha: 1,
				y: 0,
				duration: 0.72,
				ease: "power3.out",
				scrollTrigger: {
					trigger: item,
					start: "top 84%",
					toggleActions: "play none none none",
				},
			},
		);
	});
}
function initServicesAnimation() {
	const services = document.querySelector("[data-services-animation]");

	if (!services) {
		return;
	}

	const servicesWord = document.querySelector(".services-word");
	const pills = services.querySelectorAll("ul > li");
	const arrow = getDiagonalArrow(services, ".text img, .text svg");
	const paragraph = services.querySelector(".text p");
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	if (prefersReducedMotion) {
		gsap.set([servicesWord, pills, arrow, paragraph], { autoAlpha: 1, clearProps: "transform,clipPath" });
		return;
	}

	gsap.fromTo(
		servicesWord,
		{ autoAlpha: 1, clipPath: "inset(0 100% 0 0)" },
		{
			clipPath: "inset(0 0% 0 0)",
			duration: 1.25,
			ease: "power2.inOut",
			scrollTrigger: {
				trigger: servicesWord,
				start: "top 86%",
				toggleActions: "play none none none",
			},
		},
	);

	gsap.to(servicesWord, {
		yPercent: 4,
		ease: "none",
		scrollTrigger: {
			trigger: servicesWord,
			start: "top bottom",
			end: "bottom top",
			scrub: 1.1,
		},
	});
	const timeline = gsap.timeline({
		defaults: { ease: "power3.out" },
		scrollTrigger: {
			trigger: services,
			start: "top 78%",
			toggleActions: "play none none none",
		},
	});

	timeline
		.from(services, {
			"--services-line-scale": 0,
			duration: 0.01,
		})
		.fromTo(
			services,
			{ "--services-line-scale": 0 },
			{ "--services-line-scale": 1, duration: 0.78, ease: "power2.inOut" },
		)
		.fromTo(
			pills,
			{ autoAlpha: 0, y: 26, scale: 0.82, rotation: -3 },
			{
				autoAlpha: 1,
				y: 0,
				scale: 1,
				rotation: 0,
				duration: 0.7,
				ease: "back.out(1.7)",
				stagger: 0.075,
			},
			"-=0.45",
		)
		.fromTo(
			arrow,
			diagonalArrowFrom(),
			diagonalArrowTo(),
			"-=0.32",
		)
		.fromTo(
			paragraph,
			{ autoAlpha: 0, y: 30 },
			{ autoAlpha: 1, y: 0, duration: 0.76, ease: "power3.out" },
			"-=0.5",
		);
}

function initServicesCardsAnimation() {
	const section = document.querySelector("#services");

	if (!section || section.dataset.servicesCardsAnimationReady === "true") {
		return;
	}

	const list = section.querySelector(".services-list");
	const cards = section.querySelectorAll(".services-list > li");

	section.dataset.servicesCardsAnimationReady = "true";

	if (!list || !cards.length || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
		gsap.set(cards, { autoAlpha: 1, clearProps: "transform" });
		return;
	}

	gsap.fromTo(
		cards,
		{ autoAlpha: 0, y: 64 },
		{
			autoAlpha: 1,
			y: 0,
			duration: 0.85,
			stagger: 0.12,
			ease: "power3.out",
			scrollTrigger: {
				trigger: list,
				start: "top 82%",
				toggleActions: "play none none none",
			},
		},
	);
}

function revealServicesInternalTopics(scope, replay = false) {
	if (!scope || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
		return;
	}

	const list = scope.matches?.(".service-internal-topics") ? scope : scope.querySelector(".service-internal-topics");
	const items = list ? Array.from(list.querySelectorAll("li")) : [];

	if (!items.length) {
		return;
	}

	gsap.killTweensOf(items);

	if (replay) {
		gsap.set(items, { autoAlpha: 0, y: 36 });
	}

	gsap.to(items, {
		autoAlpha: 1,
		y: 0,
		duration: 0.72,
		stagger: 0.12,
		ease: "power3.out",
		overwrite: "auto",
	});
}

function initServicesInternalTopicsAnimation() {
	const section = document.querySelector("#servicesInternal");

	if (!section || section.dataset.servicesInternalTopicsAnimationReady === "true") {
		return;
	}

	const lists = section.querySelectorAll(".service-internal-topics");
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	section.dataset.servicesInternalTopicsAnimationReady = "true";

	if (!lists.length) {
		return;
	}

	if (prefersReducedMotion) {
		gsap.set(lists, { autoAlpha: 1, clearProps: "transform" });
		gsap.set(section.querySelectorAll(".service-internal-topics li"), { autoAlpha: 1, clearProps: "transform" });
		return;
	}

	lists.forEach((list) => {
		const items = list.querySelectorAll("li");

		gsap.set(items, { autoAlpha: 0, y: 36 });

		gsap.to(items, {
			autoAlpha: 1,
			y: 0,
			duration: 0.72,
			stagger: 0.12,
			ease: "power3.out",
			overwrite: "auto",
			scrollTrigger: {
				trigger: list,
				start: "top 82%",
				toggleActions: "play none none none",
			},
		});
	});
}

window.revealServicesInternalTopics = revealServicesInternalTopics;
function initDeepAnimation() {
	const sections = document.querySelectorAll("#deep, #deep-inside");

	if (!sections.length) {
		return;
	}

	sections.forEach((section) => {
		if (section.dataset.deepAnimationReady === "true") {
			return;
		}

		const wave = section.querySelector(".wavedeep");
		const circle = section.querySelector(".circledeep");
		const title = section.querySelector(".texts h2");
		const paragraph = section.querySelector(".texts p");
		const scrollLink = section.querySelector(".deep-scroll-link");
		const textArrow = getDiagonalArrow(section, ".texts .arrow img, .texts .arrow svg");
		const list = section.querySelector(".deep > ul, ul#deep-list");
		const listItems = list ? Array.from(list.children).filter((item) => item.matches("li")) : [];
		const infos = section.querySelector(".infos");
		const infoArrow = getDiagonalArrow(section, ".infos .text img, .infos .text svg");
		const infoText = section.querySelector(".infos .text p");
		const infoButton = section.querySelector(".infos .btn");
		const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

		section.dataset.deepAnimationReady = "true";

		if (prefersReducedMotion) {
			gsap.set([wave, circle, title, paragraph, scrollLink, textArrow, ...listItems, infoArrow, infoText, infoButton].filter(Boolean), { autoAlpha: 1, clearProps: "transform,clipPath" });
			gsap.set(listItems, { "--deep-line-scale": 1 });
			return;
		}

		gsap.set([wave, circle].filter(Boolean), { transformOrigin: "50% 50%" });
		gsap.set([textArrow, infoArrow].filter(Boolean), { transformOrigin: "50% 50%" });

		const introTimeline = gsap.timeline({
			defaults: { ease: "power3.out" },
			scrollTrigger: {
				trigger: section,
				start: "top 72%",
				toggleActions: "play none none none",
			},
		});

		if (wave) {
			introTimeline.fromTo(
				wave,
				{ autoAlpha: 1, clipPath: "inset(0 100% 0 0)" },
				{ clipPath: "inset(0 0% 0 0)", duration: 1.5, ease: "power2.inOut" },
			);
		}

		if (circle) {
			introTimeline.fromTo(
				circle,
				{ autoAlpha: 0, scale: 0.18 },
				{ autoAlpha: 1, scale: 1, duration: 1.25, ease: "power3.out" },
				wave ? "-=0.9" : 0,
			);
		}

		if (textArrow) {
			introTimeline.fromTo(
				textArrow,
				diagonalArrowFrom(),
				diagonalArrowTo(),
				"-=0.62",
			);
		}

		if (title) {
			introTimeline.fromTo(title, { autoAlpha: 0, y: 38 }, { autoAlpha: 1, y: 0, duration: 0.8 }, "-=0.62");
		}

		if (paragraph) {
			introTimeline.fromTo(paragraph, { autoAlpha: 0, y: 30 }, { autoAlpha: 1, y: 0, duration: 0.72 }, "-=0.48");
		}

		if (scrollLink) {
			introTimeline.fromTo(scrollLink, { autoAlpha: 0, y: 20 }, { autoAlpha: 1, y: 0, duration: 0.6 }, "-=0.4");
		}

		if (list && listItems.length) {
			gsap.fromTo(
				listItems,
				{ "--deep-line-scale": 0 },
				{
					"--deep-line-scale": 1,
					ease: "none",
					scrollTrigger: {
						trigger: list,
						start: "top 125%",
						end: "top 59%",
						scrub: true,
					},
				},
			);

			gsap.fromTo(
				listItems,
				{ autoAlpha: 0, y: 36 },
				{
					immediateRender: false,
					autoAlpha: 1,
					y: 0,
					duration: 0.75,
					stagger: 0.14,
					ease: "power3.out",
					scrollTrigger: {
						trigger: list,
						start: "top 84%",
						toggleActions: "play none none none",
					},
				},
			);
		}

		if (infos && infoArrow && infoText && infoButton) {
			gsap.timeline({
				defaults: { ease: "power3.out" },
				scrollTrigger: {
					trigger: infos,
					start: "top 78%",
					toggleActions: "play none none none",
				},
			})
				.fromTo(
					infoArrow,
					diagonalArrowFrom(),
					diagonalArrowTo(),
				)
				.fromTo(infoText, { autoAlpha: 0, y: 30 }, { autoAlpha: 1, y: 0, duration: 0.72 }, "-=0.38")
				.fromTo(infoButton, { autoAlpha: 0, y: 28 }, { autoAlpha: 1, y: 0, duration: 0.68 }, "-=0.42");
		}
	});
}
function initAboutQAnimation() {
	const aboutGraphic = document.querySelector("[data-about-animation]");

	if (!aboutGraphic) {
		return;
	}

	const section = aboutGraphic.closest("#about") || aboutGraphic;
	const heading = section.querySelector(".hat");
	const circleItems = aboutGraphic.querySelectorAll(".circle1, .circle2");
	const circlePaths = aboutGraphic.querySelectorAll(".circle1 path, .circle2 path");
	const textBlocks = aboutGraphic.querySelectorAll("h2, h3");

	textBlocks.forEach(wrapAboutWords);

	if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
		return;
	}

	circlePaths.forEach((path) => {
		const length = path.getTotalLength();
		gsap.set(path, {
			strokeDasharray: length,
			strokeDashoffset: length,
		});
	});

	const leadWords = aboutGraphic.querySelectorAll(".aboutCircle__lead .about-word");
	const supportWords = aboutGraphic.querySelectorAll(".aboutCircle__support .about-word");
	const supportLabel = aboutGraphic.querySelector(".aboutCircle__support h3 > span");
	const timeline = gsap.timeline({
		defaults: { ease: "power3.out" },
		scrollTrigger: {
			trigger: section,
			start: "top 82%",
			toggleActions: "play none none none",
		},
	});

	timeline
		.from(heading, {
			autoAlpha: 0,
			y: 18,
			duration: 0.55,
		})
		.fromTo(
			circleItems,
			{
				autoAlpha: 0,
				scale: 0.58,
				x: (index) => (index === 0 ? -130 : 130),
				rotation: (index) => (index === 0 ? -16 : 16),
			},
			{
				autoAlpha: 1,
				scale: 1,
				x: 0,
				rotation: 0,
				duration: 1.25,
				ease: "elastic.out(1, 0.68)",
				stagger: 0.14,
			},
			"-=0.1",
		)
		.to(
			circlePaths,
			{
				strokeDashoffset: 0,
				duration: 1.2,
				ease: "power3.inOut",
				stagger: 0.12,
			},
			"-=0.92",
		)
		.fromTo(
			leadWords,
			{ autoAlpha: 0, yPercent: 90, rotationX: -55, transformPerspective: 600 },
			{ autoAlpha: 1, yPercent: 0, rotationX: 0, duration: 0.78, stagger: 0.045 },
			"-=0.62",
		)
		.fromTo(
			supportLabel,
			{ autoAlpha: 0, x: 34 },
			{ autoAlpha: 1, x: 0, duration: 0.62 },
			"-=0.36",
		)
		.fromTo(
			supportWords,
			{ autoAlpha: 0, y: 28, scale: 0.96 },
			{ autoAlpha: 1, y: 0, scale: 1, duration: 0.62, stagger: 0.035 },
			"-=0.42",
		)
		.to(
			circlePaths,
			{
				scale: 1.018,
				duration: 0.48,
				repeat: 1,
				yoyo: true,
				ease: "sine.inOut",
				stagger: 0.08,
			},
			"-=0.28",
		)
		.add(() => {
			gsap.to(circleItems, {
				scale: (index) => (index === 0 ? 1.018 : 1.012),
				duration: 3.4,
				repeat: -1,
				yoyo: true,
				ease: "sine.inOut",
				stagger: 0.32,
			});
		});
}

function wrapStrategyWords(element) {
	if (!element || element.dataset.strategyWordsReady === "true") {
		return;
	}

	const labels = Array.from(element.childNodes)
		.map((node) => node.textContent.trim())
		.filter(Boolean);
	const fragment = document.createDocumentFragment();

	labels.forEach((label) => {
		const word = document.createElement("span");
		word.className = "strategy-word";
		word.textContent = label;
		fragment.appendChild(word);
	});

	element.textContent = "";
	element.appendChild(fragment);
	element.dataset.strategyWordsReady = "true";
}

function initProjectsAnimation() {
	const section = document.querySelector("[data-projects-animation]");

	if (!section || section.dataset.projectsAnimationReady === "true") {
		return;
	}

	const word = section.querySelector(".projects-word");
	const hat = section.querySelector(".container > .hat");
	const featured = section.querySelector(".project-featured");
	const listing = section.querySelector(".project-listing");
	const featuredCards = featured ? featured.querySelectorAll(".project-card") : [];
	const listingCards = listing ? listing.querySelectorAll(".project-card") : [];
	const others = section.querySelector(".others");
	const othersTitle = others ? others.querySelector(".hat") : null;
	const othersPills = others ? others.querySelectorAll("li") : [];
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	section.dataset.projectsAnimationReady = "true";

	if (prefersReducedMotion) {
		gsap.set([word, hat, featured, listing, featuredCards, listingCards, othersTitle, othersPills], { autoAlpha: 1, clearProps: "transform,filter,clipPath" });
		return;
	}

	gsap.timeline({
		defaults: { ease: "power3.out" },
		scrollTrigger: {
			trigger: section,
			start: "top 72%",
			toggleActions: "play none none none",
		},
	})
		.fromTo(
			word,
			{ autoAlpha: 1, clipPath: "inset(0 100% 0 0)" },
			{ clipPath: "inset(0 0% 0 0)", duration: 1.25, ease: "power2.inOut" },
		)
		.fromTo(hat, { autoAlpha: 0, y: 24 }, { autoAlpha: 1, y: 0, duration: 0.58 }, "-=0.62")
		.fromTo(
			featured,
			{ autoAlpha: 0, y: 54, scale: 0.985 },
			{ autoAlpha: 1, y: 0, scale: 1, duration: 0.9 },
			"-=0.22",
		)
		.fromTo(
			featuredCards,
			{ autoAlpha: 0, y: 34, scale: 0.975 },
			{ autoAlpha: 1, y: 0, scale: 1, duration: 0.72, stagger: 0.06 },
			"-=0.72",
		);

	if (listing && listingCards.length) gsap.timeline({
		defaults: { ease: "power3.out" },
		scrollTrigger: {
			trigger: listing,
			start: "top 78%",
			toggleActions: "play none none none",
		},
	})
		.fromTo(listing, { autoAlpha: 0, y: 46 }, { autoAlpha: 1, y: 0, duration: 0.82 })
		.fromTo(
			listingCards,
			{ autoAlpha: 0, y: 34, scale: 0.975 },
			{ autoAlpha: 1, y: 0, scale: 1, duration: 0.72, stagger: 0.06 },
			"-=0.62",
		);

	if (others && othersTitle && othersPills.length) gsap.timeline({
		defaults: { ease: "power3.out" },
		scrollTrigger: {
			trigger: others,
			start: "top 82%",
			toggleActions: "play none none none",
		},
	})
		.fromTo(othersTitle, { autoAlpha: 0, y: 24 }, { autoAlpha: 1, y: 0, duration: 0.62 })
		.fromTo(
			othersPills,
			{ autoAlpha: 0, y: 26, scale: 0.82, rotation: -3 },
			{
				autoAlpha: 1,
				y: 0,
				scale: 1,
				rotation: 0,
				duration: 0.7,
				ease: "back.out(1.7)",
				stagger: 0.075,
			},
			"-=0.34",
		);

	gsap.to(word, {
		yPercent: 4,
		ease: "none",
		scrollTrigger: {
			trigger: section,
			start: "top bottom",
			end: "bottom top",
			scrub: 1.1,
		},
	});
}

function initClientAnimation() {
	const section = document.querySelector("[data-client-animation]");

	if (!section || section.dataset.clientAnimationReady === "true") {
		return;
	}

	const hat = section.querySelector(".hat");
	const title = section.querySelector("h2");
	const arrow = getDiagonalArrow(section, ".info img, .info svg");
	const text = section.querySelector(".info p");
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	section.dataset.clientAnimationReady = "true";

	if (prefersReducedMotion) {
		gsap.set([hat, title, arrow, text], { autoAlpha: 1, clearProps: "transform,clipPath" });
		return;
	}

	gsap.timeline({
		defaults: { ease: "power3.out" },
		scrollTrigger: {
			trigger: section,
			start: "top 76%",
			toggleActions: "play none none none",
		},
	})
		.fromTo(hat, { autoAlpha: 0, y: 24 }, { autoAlpha: 1, y: 0, duration: 0.58 })
		.fromTo(
			title,
			{ autoAlpha: 0, y: 30, clipPath: "inset(0 0 100% 0)" },
			{ autoAlpha: 1, y: 0, clipPath: "inset(0 0 0% 0)", duration: 0.82, ease: "power3.inOut" },
			"-=0.22",
		)
		.fromTo(
			arrow,
			diagonalArrowFrom(),
			diagonalArrowTo(),
			"-=0.34",
		)
		.fromTo(text, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.72, ease: "power2.out" }, "-=0.38");
}

function initStrategyAnimation() {
	const section = document.querySelector("[data-strategy-animation]");

	if (!section || section.dataset.strategyAnimationReady === "true") {
		return;
	}

	const title = section.querySelector("h2");
	const paragraph = section.querySelector("p");
	const wave = section.querySelector(".wave");
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	section.dataset.strategyAnimationReady = "true";
	if (!title || !paragraph || !wave) {
		return;
	}

	if (prefersReducedMotion) {
		gsap.set(title, { autoAlpha: 0 });
		gsap.set([paragraph, wave], {
			autoAlpha: 1,
			clipPath: "inset(0 0% 0 0)",
			clearProps: "transform",
		});
		return;
	}

	wrapStrategyWords(title);

	const words = section.querySelectorAll(".strategy-word");

	gsap.set(words, { autoAlpha: 0, y: 24 });
	gsap.set(paragraph, { autoAlpha: 0, y: 24 });
	gsap.set(wave, {
		clipPath: "inset(0 100% 0 0)",
		transformOrigin: "left center",
	});

	const timeline = gsap.timeline({
		defaults: { ease: "power3.out" },
		scrollTrigger: {
			trigger: section,
			start: "top 72%",
			toggleActions: "play none none none",
		},
	});

	timeline
		.to(wave, { clipPath: "inset(0 0% 0 0)", duration: 1.65, ease: "power2.inOut" }, 0)
		.to(words, { autoAlpha: 1, y: 0, duration: 0.9, stagger: 0.45 }, 0.12)
		.to({}, { duration: 1.15 })
		.to(words, { autoAlpha: 0, y: -18, duration: 0.5, stagger: 0.08, ease: "power2.in" })
		.to(paragraph, { autoAlpha: 1, y: 0, duration: 0.78 }, "-=0.08");
}

function initIntelligenceAnimation() {
	const section = document.querySelector("#intelligence");

	if (!section || section.dataset.intelligenceAnimationReady === "true") {
		return;
	}

	const topTexts = section.querySelectorAll(".top p");
	const topRule = section.querySelector(".top hr");
	const circleGraphic = section.querySelector(".intelligence-circle");
	const title = section.querySelector("h2");
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	const fadeItems = [...topTexts, title].filter(Boolean);

	section.dataset.intelligenceAnimationReady = "true";

	if (prefersReducedMotion) {
		gsap.set([topRule, circleGraphic, ...fadeItems].filter(Boolean), { autoAlpha: 1, clearProps: "transform" });
		if (circleGraphic instanceof SVGElement) {
			gsap.set(circleGraphic.querySelectorAll("path[stroke], line[stroke]"), { strokeDashoffset: 0 });
		}
		return;
	}

	if (fadeItems.length || topRule) {
		const introTimeline = gsap.timeline({
			defaults: { ease: "power3.out" },
			scrollTrigger: {
				trigger: section,
				start: "top 78%",
				toggleActions: "play none none none",
			},
		});

		if (fadeItems.length) {
			introTimeline.fromTo(fadeItems, { autoAlpha: 0, y: 32 }, { autoAlpha: 1, y: 0, duration: 0.72, stagger: 0.12 });
		}

		if (topRule) {
			gsap.set(topRule, { transformOrigin: "50% 0%" });
			introTimeline.fromTo(topRule, { autoAlpha: 0, scaleY: 0 }, { autoAlpha: 1, scaleY: 1, duration: 0.7 }, "-=0.48");
		}
	}

	if (!(circleGraphic instanceof SVGElement)) {
		if (circleGraphic) {
			gsap.fromTo(
				circleGraphic,
				{ autoAlpha: 0, scale: 0.94 },
				{
					autoAlpha: 1,
					scale: 1,
					duration: 0.9,
					ease: "power3.out",
					scrollTrigger: {
						trigger: circleGraphic,
						start: "top 82%",
						toggleActions: "play none none none",
					},
				},
			);
		}
		return;
	}

	const finalLine = circleGraphic.querySelector("line[stroke]");
	const finalDot = circleGraphic.querySelector('circle[cy="1317"]');
	const strokeItems = Array.from(circleGraphic.querySelectorAll("path[stroke]")).filter((item) => typeof item.getTotalLength === "function");
	const textItems = circleGraphic.querySelectorAll('path[fill="white"]');
	const circleItems = Array.from(circleGraphic.querySelectorAll("circle, ellipse")).filter((item) => item !== finalDot);
	const drawableItems = [...strokeItems, finalLine].filter((item) => item && typeof item.getTotalLength === "function");

	drawableItems.forEach((item) => {
		const length = item.getTotalLength();
		gsap.set(item, {
			strokeDasharray: length,
			strokeDashoffset: length,
		});
	});

	gsap.set(circleGraphic, { autoAlpha: 1 });
	gsap.set([...textItems, ...circleItems], { autoAlpha: 0, scale: 0.9, transformOrigin: "50% 50%" });
	if (finalDot) {
		gsap.set(finalDot, { autoAlpha: 0, scale: 0.55, transformOrigin: "50% 50%" });
	}

	const graphicTimeline = gsap.timeline({
		defaults: { ease: "power3.out" },
		scrollTrigger: {
			trigger: circleGraphic,
			start: "top 78%",
			toggleActions: "play none none none",
		},
	});

	if (strokeItems.length) {
		graphicTimeline.to(strokeItems, { strokeDashoffset: 0, duration: 1.35, stagger: 0.08, ease: "power2.inOut" });
	}

	if (circleItems.length) {
		graphicTimeline.to(circleItems, { autoAlpha: 1, scale: 1, duration: 0.82, stagger: 0.08 }, "-=0.86");
	}

	if (textItems.length) {
		graphicTimeline.to(textItems, { autoAlpha: 1, scale: 1, duration: 0.72, stagger: 0.012 }, "-=0.62");
	}

	if (finalLine) {
		graphicTimeline.to(finalLine, { strokeDashoffset: 0, duration: 0.9, ease: "power2.inOut" }, "-=0.16");
	}

	if (finalDot) {
		graphicTimeline.to(finalDot, { autoAlpha: 1, scale: 1, duration: 0.52, ease: "back.out(1.7)" }, "-=0.06");
	}
}
function initStrandsAnimation() {
	const section = document.querySelector("#strands");

	if (!section || section.dataset.strandsAnimationReady === "true") {
		return;
	}

	const circleGraphic = section.querySelector(".strands-circle");
	const list = section.querySelector("ul");
	const listItems = list ? Array.from(list.querySelectorAll("li")) : [];
	const listRules = list ? list.querySelectorAll("hr") : [];
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	section.dataset.strandsAnimationReady = "true";

	if (prefersReducedMotion) {
		gsap.set([circleGraphic, ...listItems, ...listRules].filter(Boolean), { autoAlpha: 1, clearProps: "transform" });
		if (circleGraphic instanceof SVGElement) {
			gsap.set(circleGraphic.querySelectorAll("circle[stroke], path[stroke], line[stroke]"), { strokeDashoffset: 0 });
		}
		return;
	}

	if (listItems.length) {
		gsap.set(listRules, { transformOrigin: "left center" });
		gsap.timeline({
			defaults: { ease: "power3.out" },
			scrollTrigger: {
				trigger: list,
				start: "top 82%",
				toggleActions: "play none none none",
			},
		})
			.fromTo(listItems, { autoAlpha: 0, y: 34 }, { autoAlpha: 1, y: 0, duration: 0.74, stagger: 0.14 })
			.fromTo(listRules, { autoAlpha: 0, scaleX: 0 }, { autoAlpha: 1, scaleX: 1, duration: 0.62, stagger: 0.1 }, "-=0.42");
	}

	if (!(circleGraphic instanceof SVGElement)) {
		if (circleGraphic) {
			gsap.fromTo(
				circleGraphic,
				{ autoAlpha: 0, scale: 0.94 },
				{
					autoAlpha: 1,
					scale: 1,
					duration: 0.9,
					ease: "power3.out",
					scrollTrigger: {
						trigger: circleGraphic,
						start: "top 82%",
						toggleActions: "play none none none",
					},
				},
			);
		}
		return;
	}

	const strokeItems = Array.from(circleGraphic.querySelectorAll("circle[stroke], path[stroke], line[stroke]")).filter((item) => typeof item.getTotalLength === "function");
	const bubbleItems = circleGraphic.querySelectorAll("circle:not([stroke]), ellipse");
	const textItems = circleGraphic.querySelectorAll('path[fill="white"]');

	strokeItems.forEach((item) => {
		const length = item.getTotalLength();
		gsap.set(item, {
			strokeDasharray: length,
			strokeDashoffset: length,
		});
	});

	gsap.set(circleGraphic, { autoAlpha: 1 });
	gsap.set([...bubbleItems, ...textItems], { autoAlpha: 0, scale: 0.9, transformOrigin: "50% 50%" });

	const graphicTimeline = gsap.timeline({
		defaults: { ease: "power3.out" },
		scrollTrigger: {
			trigger: circleGraphic,
			start: "top 78%",
			toggleActions: "play none none none",
		},
	});

	if (strokeItems.length) {
		graphicTimeline.to(strokeItems, { strokeDashoffset: 0, duration: 1.28, stagger: 0.08, ease: "power2.inOut" });
	}

	if (bubbleItems.length) {
		graphicTimeline.to(bubbleItems, { autoAlpha: 1, scale: 1, duration: 0.82, stagger: 0.08 }, "-=0.72");
	}

	if (textItems.length) {
		graphicTimeline.to(textItems, { autoAlpha: 1, scale: 1, duration: 0.68, stagger: 0.012 }, "-=0.56");
	}
}

function initConsistencyAnimation() {
	const section = document.querySelector("#consistency");

	if (!section || section.dataset.consistencyAnimationReady === "true") {
		return;
	}

	const box = section.querySelector(".consistency-box");
	const title = section.querySelector(".consistency-heading h2");
	const headingText = section.querySelector(".consistency-heading p");
	const rule = section.querySelector(".consistency-content > hr");
	const textItems = section.querySelectorAll(".consistency-texts p");
	const revealItems = [title, headingText, ...textItems].filter(Boolean);
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	section.dataset.consistencyAnimationReady = "true";

	if (!box) {
		return;
	}

	if (prefersReducedMotion) {
		gsap.set(box, { "--consistency-border-progress": "100%" });
		gsap.set([rule, ...revealItems].filter(Boolean), { autoAlpha: 1, clearProps: "transform" });
		return;
	}

	gsap.set(box, { "--consistency-border-progress": "0%" });
	if (rule) {
		gsap.set(rule, { transformOrigin: "left center" });
	}

	const timeline = gsap.timeline({
		defaults: { ease: "power3.out" },
		scrollTrigger: {
			trigger: box,
			start: "top 76%",
			toggleActions: "play none none none",
		},
	});

	timeline.to(box, { "--consistency-border-progress": "100%", duration: 1.12, ease: "power2.inOut" });

	if (title) {
		timeline.fromTo(title, { autoAlpha: 0, y: 42 }, { autoAlpha: 1, y: 0, duration: 0.8 }, "-=0.58");
	}

	if (headingText) {
		timeline.fromTo(headingText, { autoAlpha: 0, y: 32 }, { autoAlpha: 1, y: 0, duration: 0.72 }, "-=0.5");
	}

	if (rule) {
		timeline.fromTo(rule, { autoAlpha: 0, scaleX: 0 }, { autoAlpha: 1, scaleX: 1, duration: 0.68 }, "-=0.42");
	}

	if (textItems.length) {
		timeline.fromTo(textItems, { autoAlpha: 0, y: 30 }, { autoAlpha: 1, y: 0, duration: 0.72, stagger: 0.14 }, "-=0.46");
	}
}
function initMetodologyAnimation() {
	const section = document.querySelector("#metodology");

	if (!section || section.dataset.metodologyAnimationReady === "true") {
		return;
	}

	const word = section.querySelector(".metodology-word");
	const title = section.querySelector(".box h2");
	const list = section.querySelector(".box ul");
	const listItems = list ? list.querySelectorAll("li") : [];
	const arrow = getDiagonalArrow(section, ".metodology-arrow");
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	section.dataset.metodologyAnimationReady = "true";

	if (prefersReducedMotion) {
		gsap.set(section, { "--metodology-gradient-scale": 1 });
		gsap.set([word, title, listItems, arrow].filter(Boolean), { autoAlpha: 1, clearProps: "transform,clipPath" });
		return;
	}

	gsap.set(section, { "--metodology-gradient-scale": 0 });
	gsap.set([word, arrow].filter(Boolean), { transformOrigin: "50% 50%" });

	const timeline = gsap.timeline({
		defaults: { ease: "power3.out" },
		scrollTrigger: {
			trigger: section,
			start: "top 72%",
			toggleActions: "play none none none",
		},
	});

	if (word) {
		timeline.fromTo(
			word,
			{ autoAlpha: 1, clipPath: "inset(0 100% 0 0)" },
			{ clipPath: "inset(0 0% 0 0)", duration: 1.25, ease: "power2.inOut" },
		);
	}

	if (title) {
		timeline.fromTo(title, { autoAlpha: 0, y: 36 }, { autoAlpha: 1, y: 0, duration: 0.78 }, "-=0.58");
	}

	timeline.to(section, { "--metodology-gradient-scale": 1, duration: 1.05, ease: "power2.inOut" }, "-=0.36");

	if (listItems.length) {
		timeline.fromTo(
			listItems,
			{ autoAlpha: 0, y: 34 },
			{ autoAlpha: 1, y: 0, duration: 0.72, stagger: 0.13 },
			"-=0.58",
		);
	}

	if (arrow) {
		timeline.fromTo(arrow, diagonalArrowFrom(), diagonalArrowTo({ duration: 0.72 }), "-=0.38");
	}

	if (word) {
		gsap.to(word, {
			yPercent: 4,
			ease: "none",
			scrollTrigger: {
				trigger: section,
				start: "top bottom",
				end: "bottom top",
				scrub: 1.1,
			},
		});
	}
}
function initMissionWordAnimation() {
	const section = document.querySelector("#mission");
	const word = section ? section.querySelector(".mission-word") : null;

	if (!section || !word || section.dataset.missionWordAnimationReady === "true") {
		return;
	}

	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	section.dataset.missionWordAnimationReady = "true";
	if (prefersReducedMotion) {
		gsap.set(word, { autoAlpha: 1, clearProps: "transform,clipPath" });
		return;
	}

	gsap.fromTo(
		word,
		{ autoAlpha: 1, clipPath: "inset(0 100% 0 0)" },
		{
			clipPath: "inset(0 0% 0 0)",
			duration: 1.25,
			ease: "power2.inOut",
			scrollTrigger: {
				trigger: word,
				start: "top 86%",
				toggleActions: "play none none none",
			},
		},
	);

	gsap.to(word, {
		yPercent: 4,
		ease: "none",
		scrollTrigger: {
			trigger: section,
			start: "top bottom",
			end: "bottom top",
			scrub: 1.1,
		},
	});
}
function initContactWordAnimation() {
	const section = document.querySelector("#contact");
	const word = section ? section.querySelector(".contact-word") : null;

	if (!section || !word || section.dataset.contactWordAnimationReady === "true") {
		return;
	}

	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	section.dataset.contactWordAnimationReady = "true";
	if (prefersReducedMotion) {
		gsap.set(word, { autoAlpha: 1, clearProps: "transform,clipPath" });
		return;
	}

	gsap.fromTo(
		word,
		{ autoAlpha: 1, clipPath: "inset(0 100% 0 0)" },
		{
			clipPath: "inset(0 0% 0 0)",
			duration: 1.25,
			ease: "power2.inOut",
			scrollTrigger: {
				trigger: word,
				start: "top 86%",
				toggleActions: "play none none none",
			},
		},
	);

	gsap.to(word, {
		yPercent: 4,
		ease: "none",
		scrollTrigger: {
			trigger: section,
			start: "top bottom",
			end: "bottom top",
			scrub: 1.1,
		},
	});
}
function initImpactAnimation() {
	const section = document.querySelector("[data-impact-animation]");

	if (!section || section.dataset.impactAnimationReady === "true") {
		return;
	}

	const introTitle = section.querySelector(".impact-intro h2");
	const introText = section.querySelector(".impact-intro .subtitle");
	const circles = section.querySelector(".impact-circles");
	const outlineCircle = section.querySelector(".impact-circle--outline");
	const gradientCircle = section.querySelector(".impact-circle--gradient");
	const endTitle = section.querySelector(".impact-title");
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	section.dataset.impactAnimationReady = "true";
	if (!introTitle || !introText || !circles || !outlineCircle || !gradientCircle || !endTitle) {
		return;
	}

	if (prefersReducedMotion) {
		gsap.set([introTitle, introText, circles, outlineCircle, gradientCircle, endTitle], { autoAlpha: 1 });
		return;
	}

	gsap.set([introTitle, introText, endTitle], { autoAlpha: 0, y: 24 });
	gsap.set(outlineCircle, {
		autoAlpha: 0,
		x: -72,
		scale: 0.88,
		transformOrigin: "50% 50%",
	});
	gsap.set(gradientCircle, {
		autoAlpha: 0,
		x: 72,
		scale: 0.88,
		transformOrigin: "50% 50%",
	});

	const timeline = gsap.timeline({
		defaults: { ease: "power3.out" },
		scrollTrigger: {
			trigger: section,
			start: "top 72%",
			toggleActions: "play none none none",
		},
	});

	timeline
		.to(outlineCircle, { autoAlpha: 1, x: 0, scale: 1, duration: 1.05 }, 0)
		.to(gradientCircle, { autoAlpha: 1, x: 0, scale: 1, duration: 1.05 }, 0.16)
		.to(introTitle, { autoAlpha: 1, y: 0, duration: 0.78 }, 0.36)
		.to(introText, { autoAlpha: 1, y: 0, duration: 0.72 }, 0.52)
		.to(endTitle, { autoAlpha: 1, y: 0, duration: 0.82 }, 0.74);
}
function initAwardsAnimation() {
	const section = document.querySelector("[data-awards-animation]");

	if (!section || section.dataset.awardsAnimationReady === "true") {
		return;
	}

	const word = section.querySelector(".awards-word");
	const title = section.querySelector("h2");
	const awardItems = section.querySelectorAll(".awards-list > li");
	const firstAward = awardItems[0];
	const trailingAwards = Array.from(awardItems).slice(1);
	const wordsList = section.querySelector(".awards-list-words");
	const words = wordsList ? wordsList.querySelectorAll("li") : [];
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	section.dataset.awardsAnimationReady = "true";

	if (prefersReducedMotion) {
		gsap.set([word, title, awardItems, words], { autoAlpha: 1, clearProps: "transform,clipPath" });
		return;
	}

	if (firstAward) {
		gsap.to(firstAward, {
			"--awards-stop-middle": "42%",
			"--awards-stop-end": "88%",
			ease: "none",
			scrollTrigger: {
				trigger: section,
				start: "top bottom",
				end: "bottom top",
				scrub: 1.8,
			},
		});
	}

	gsap.timeline({
		defaults: { ease: "power3.out" },
		scrollTrigger: {
			trigger: section,
			start: "top 72%",
			toggleActions: "play none none none",
		},
	})
		.fromTo(
			word,
			{ autoAlpha: 1, clipPath: "inset(0 100% 0 0)" },
			{ clipPath: "inset(0 0% 0 0)", duration: 1.25, ease: "power2.inOut" },
		)
		.fromTo(title, { autoAlpha: 0, y: 24 }, { autoAlpha: 1, y: 0, duration: 0.62 }, "-=0.62")
		.fromTo(
			trailingAwards,
			{ xPercent: (index) => -100 * (index + 1), autoAlpha: 1 },
			{ xPercent: 0, duration: 1.05, stagger: 0.16, ease: "power3.inOut" },
			"-=0.08",
		);

	gsap.set(words, { autoAlpha: 0, y: 64, scale: 0.94 });

	if (wordsList && words.length && typeof ScrollTrigger !== "undefined") {
		ScrollTrigger.create({
		trigger: wordsList,
		start: "top 76%",
			onEnter: () => {
				gsap.to(words, {
				autoAlpha: 1,
				y: 0,
				scale: 1,
				duration: 1,
				stagger: 0.22,
				ease: "power3.out",
			});
			},
		});
	}

	gsap.to(word, {
		yPercent: 4,
		ease: "none",
		scrollTrigger: {
			trigger: section,
			start: "top bottom",
			end: "bottom top",
			scrub: 1.1,
		},
	});
}

function initDiagonalArrowAnimations() {
	const arrows = Array.from(document.querySelectorAll('img[src*="arrow-diagonal.svg"]:not([data-diagonal-arrow-animation])'))
		.filter((arrow) => !arrow.closest(".services-list"));

	if (!arrows.length) {
		return;
	}

	if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
		gsap.set(arrows, { autoAlpha: 1, clearProps: "transform" });
		return;
	}

	arrows.forEach((arrow) => {
		arrow.dataset.diagonalArrowAnimation = "handled";
		gsap.set(arrow, { transformOrigin: "50% 50%" });

		gsap.fromTo(
			arrow,
			diagonalArrowFrom(),
			{
				...diagonalArrowTo({ duration: 0.72 }),
				scrollTrigger: {
					trigger: arrow.closest("section") || arrow,
					start: "top 82%",
					toggleActions: "play none none none",
				},
			},
		);
	});
}

function initNewsletterGradientAnimation() {
	const newsletter = document.querySelector("#newsletter");

	if (!newsletter || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
		return;
	}

	gsap.to(newsletter, {
		"--newsletter-stop-end": "82%",
		ease: "none",
		scrollTrigger: {
			trigger: newsletter,
			start: "top bottom",
			end: "bottom top",
			scrub: 1.8,
		},
	});
}
function initPortfolioServicesAnimation() {
	const sections = document.querySelectorAll("#portfolioServices, #relatedProjects");

	if (!sections.length) {
		return;
	}

	sections.forEach((section) => {
		if (section.dataset.portfolioServicesAnimationReady === "true") {
			return;
		}

		const pill = section.querySelector(".pill");
		const slider = section.querySelector(".portfolio-services-slider");
		const revealItems = [pill, slider].filter(Boolean);
		const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

		section.dataset.portfolioServicesAnimationReady = "true";

		if (!revealItems.length) {
			return;
		}

		if (prefersReducedMotion) {
			gsap.set(revealItems, { autoAlpha: 1, clearProps: "transform" });
			return;
		}

		gsap.fromTo(
			revealItems,
			{ autoAlpha: 0, y: 42 },
			{
				autoAlpha: 1,
				y: 0,
				duration: 0.82,
				stagger: 0.14,
				ease: "power3.out",
				overwrite: "auto",
				scrollTrigger: {
					trigger: section,
					start: "top 78%",
					toggleActions: "play none none none",
				},
			},
		);
	});
}
function initPartnersAnimation() {
	const section = document.querySelector("#partners");

	if (!section || section.dataset.partnersAnimationReady === "true") {
		return;
	}

	const top = section.querySelector(".top");
	const title = section.querySelector(".top h2");
	const arrow = getDiagonalArrow(section, ".top .texts img, .top .texts svg");
	const text = section.querySelector(".top .texts p");
	const list = section.querySelector("ul");
	const cards = section.querySelectorAll("ul > li");
	const cardTitles = section.querySelectorAll("ul > li .box h3");
	const cardInfos = section.querySelectorAll("ul > li .infos p, ul > li .infos a");
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	section.dataset.partnersAnimationReady = "true";

	if (prefersReducedMotion) {
		gsap.set([title, arrow, text, cards, cardTitles, cardInfos], { autoAlpha: 1, clearProps: "transform,clipPath" });
		return;
	}

	gsap.set(arrow, { transformOrigin: "50% 50%" });
	gsap.set([cardTitles, cardInfos], { autoAlpha: 0, y: 28 });

	gsap.timeline({
		defaults: { ease: "power3.out" },
		scrollTrigger: {
			trigger: top,
			start: "top 76%",
			toggleActions: "play none none none",
		},
	})
		.fromTo(title, { autoAlpha: 0, y: 34 }, { autoAlpha: 1, y: 0, duration: 0.78 })
		.fromTo(
			arrow,
			diagonalArrowFrom(),
			diagonalArrowTo(),
			"-=0.36",
		)
		.fromTo(text, { autoAlpha: 0, y: 30 }, { autoAlpha: 1, y: 0, duration: 0.72 }, "-=0.38");

	if (list && cards.length) {
		gsap.timeline({
			defaults: { ease: "power3.out" },
			scrollTrigger: {
				trigger: list,
				start: "top 78%",
				toggleActions: "play none none none",
			},
		})
			.fromTo(
				cards,
				{ autoAlpha: 0, y: 54 },
				{ autoAlpha: 1, y: 0, duration: 0.82, stagger: 0.16 },
			)
			.to(cardTitles, { autoAlpha: 1, y: 0, duration: 0.68, stagger: 0.12 }, "-=0.42")
			.to(cardInfos, { autoAlpha: 1, y: 0, duration: 0.68, stagger: 0.08 }, "-=0.36");
	}
}

function initGsapAnimations() {
	if (typeof gsap === "undefined" || document.documentElement.dataset.gsapAnimationsReady === "true") {
		return;
	}

	document.documentElement.dataset.gsapAnimationsReady = "true";
	if (typeof ScrollTrigger !== "undefined") {
		gsap.registerPlugin(ScrollTrigger);
	}
	const motionMedia = gsap.matchMedia();
	const waveInjection = injectWave();

	initHeaderTitleAnimation();
	initBannerTextAnimation();
	initBannerCircleAnimation();
	initServicesAnimation();
	initAboutInsideAnimation();
	initServicesCardsAnimation();
	initServicesInternalTopicsAnimation();
	initDeepAnimation();
	initAboutQAnimation();
	initClientAnimation();
	initProjectsAnimation();
	initConsistencyAnimation();
	initMetodologyAnimation();
	initMissionWordAnimation();
	initContactWordAnimation();
	initImpactAnimation();
	initAwardsAnimation();
	initNewsletterGradientAnimation();
	initPortfolioServicesAnimation();
	initPartnersAnimation();
	initDiagonalArrowAnimations();

	waveInjection.then(() => {
		initBannerWaveReveal();
		initStrategyAnimation();
		initIntelligenceAnimation();
		initStrandsAnimation();

		if (typeof ScrollTrigger !== "undefined") {
			ScrollTrigger.refresh();
		}
	});

	motionMedia.add({
		reduceMotion: "(prefers-reduced-motion: reduce)",
		allowMotion: "(prefers-reduced-motion: no-preference)",
	}, (context) => {
		const { reduceMotion } = context.conditions;
		const revealNodes = document.querySelectorAll("[data-lg-reveal]");
		revealNodes.forEach((element) => {
		const revealType = element.getAttribute("data-lg-reveal");
		const customDelay = Number.parseFloat(element.getAttribute("data-lg-delay"));
		const delay = Number.isFinite(customDelay) ? Math.max(0, customDelay) : 0;
		const from = revealType === "fade" ? { opacity: 0 } : { opacity: 0, y: 24 };

		if (revealType === "fade-to-left") {
			from.x = -40;
			from.y = 0;
		}

		if (revealType === "fade-to-right") {
			from.x = 40;
			from.y = 0;
		}

		if (revealType === "fade-to-top") {
			from.y = 30;
		}

		const to = {
			opacity: 1,
			duration: 0.8,
			delay,
			ease: "power2.out",
			overwrite: "auto",
			scrollTrigger: {
				trigger: element,
				start: "top 88%",
				toggleActions: "play none none none",
			},
		};

		if (revealType !== "fade") {
			to.x = 0;
			to.y = 0;
		}

		if (reduceMotion) {
			gsap.set(element, { opacity: 1, clearProps: "transform" });
			return;
		}

		gsap.fromTo(element, from, to);
		});

		if (reduceMotion) return;

		const parallaxNodes = document.querySelectorAll("[data-lg-parallax]");
		parallaxNodes.forEach((element) => {
		const amplitude = Number.parseFloat(element.getAttribute("data-lg-parallax-amplitude")) || 0.15;
		const inertia = Number.parseFloat(element.getAttribute("data-lg-parallax-inertia")) || 0.2;

		gsap.to(element, {
			yPercent: amplitude * 100,
			ease: "none",
			overwrite: "auto",
			scrollTrigger: {
				trigger: element,
				start: "top bottom",
				end: "bottom top",
				scrub: Math.max(0.1, inertia * 10),
			},
		});
		});
	});
	if (typeof ScrollTrigger !== "undefined") {
		const refreshScrollTriggers = () => {
			requestAnimationFrame(() => ScrollTrigger.refresh());
		};

		if (document.readyState === "complete") {
			refreshScrollTriggers();
		} else {
			window.addEventListener("load", refreshScrollTriggers, { once: true });
		}

		if (document.fonts && document.fonts.ready) {
			document.fonts.ready.then(refreshScrollTriggers);
		}
	}
}

window.initGsapAnimations = initGsapAnimations;


















